import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ToastContainer } from "react-toastify";
var HomeLayout = function (_a) {
    var children = _a.children;
    return (_jsxs("div", { className: "flex flex-col h-screen", children: [_jsx(TopBar, {}), _jsx(ToastContainer, {}), _jsx(Navbar, {}), _jsx("main", { children: children }), _jsx(Footer, {})] }));
};
export default HomeLayout;
